export default __webpack_public_path__ + "static/media/microsoft-logo-small.25ef6a79.svg";